import React from 'react';
import { sendEvent } from '@/utils/site-track';

export const usePageStayDuration = (eventData?: Record<string, string>) => {
  const startRef = React.useRef<number>(0);
  const activeTimeRef = React.useRef<number>(0);
  const visibleRef = React.useRef<boolean>(true);

  React.useEffect(() => {
    // 页面初次可见时开始计时
    startRef.current = Date.now();

    const handleVisibilityChange = () => {
      if (document.hidden) {
        // 页面隐藏 -> 记录已使用时间
        activeTimeRef.current += Date.now() - startRef.current;
        visibleRef.current = false;
      } else {
        // 页面重新可见 -> 重新开始计时
        startRef.current = Date.now();
        visibleRef.current = true;
      }
    };

    const handleSend = () => {
      let total = activeTimeRef.current;

      // 若当前仍可见，需要加上最后一段
      if (visibleRef.current) {
        total += Date.now() - startRef.current;
      }
      const duration = Math.round(total / 1000);
      sendEvent({
        name: 'page_stay_duration',
        duration: duration,
        ...eventData,
      });
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    window.addEventListener('beforeunload', handleSend);

    return () => {
      handleSend();
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      window.removeEventListener('beforeunload', handleSend);
    };
  }, []);
};
